// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>3</span>&nbsp;&nbsp;For my soul is full of troubles;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;my life draws near to the land of death.<br> </p> </div></div>";
// Exports
module.exports = code;